import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import { Spin } from 'antd';
import Tasks from '../../components/Tasks';

import getCustomerTasksQuery from '../../graphql/queries/getCustomerTasksQuery.graphql';

const CustomerTasks = (props) => (
  <Query query={getCustomerTasksQuery} variables={{ customer_id: props.match.params.id }}>
    {({ loading, error, data }) => {
      if (loading) return <Spin size="large" />;
      if (error) return `Error! ${error.message}`;

      return (
        <div style={{ backgroundColor: '#FFFFFF' }}>
          <Tasks customer_id={props.match.params.id} tasks={data.tasks} />
        </div>
      );
    }}
  </Query>
);

CustomerTasks.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default CustomerTasks;



// WEBPACK FOOTER //
// ./src/pages/customer/CustomerTasks.jsx